// Capture before app analytics load. Only short-lived opaque credentials are
// kept in this tab; partner registration PII is never persisted by the browser.
const KEY = "rxrooster.coverage.arrival.v3";
const TTL = 45 * 60 * 1000;
let memory = null; // Supports the current tab when browser storage is blocked.
export function readCoverageHandoff() {
  try {
    const data = memory || JSON.parse(sessionStorage.getItem(KEY));
    return data && Date.now() - data.createdAt < TTL ? data : null;
  } catch {
    return memory && Date.now() - memory.createdAt < TTL ? memory : null;
  }
}
export function saveCoverageHandoff(data) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
    memory = null;
  } catch {
    memory = data;
  }
}
export function clearCoverageHandoff() {
  memory = null;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* No persisted data. */
  }
}
export function captureCoverageHandoff() {
  if (
    typeof window === "undefined" ||
    window.location.pathname !== "/coverage/continue"
  )
    return;
  const handoff = new URLSearchParams(window.location.hash.slice(1)).get(
    "handoff",
  );
  if (!handoff) return;
  window.history.replaceState(
    null,
    "",
    window.location.pathname + window.location.search,
  );
  if (!/^link_[A-Za-z0-9_-]{43}$/.test(handoff)) return;
  const current = readCoverageHandoff();
  if (current?.handoff === handoff) return;
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const verifier = btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
  saveCoverageHandoff({ handoff, verifier, createdAt: Date.now() });
}
captureCoverageHandoff();
